import React, { Fragment } from "react";
import { Card, CardBody, CardHeader, Col, Table } from "reactstrap";
import { H3, H5, Image, P } from "../../../AbstractElements";
import { Connections, serviceRequest } from "../../../Constant";
import { ActivityData } from "../../../Data/Dashboard/Default/Data";
import { Link, NavLink } from 'react-router-dom';

const ActivityReview = (connections, { error }) => {
    const connnection = connections.connections.connections;
    return (
        <Fragment>
            <Col xl="3" md="6" lg="4">
                <Card className="activity-review" style={{ height: '290px' }}>
                    <CardHeader className="pb-0">
                        <H3> {serviceRequest} </H3>
                    </CardHeader>
                    <CardBody>
                        {error ? (<span>{error}</span>
                        ) : (
                            <div className="table-responsive connection-div" >
                                <Table className="table table-bordernone" >
                                    <tbody>
                                        {connnection.map((data, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>
                                                        {
                                                            index === 4 && <hr className="mt-0 bg-primary" style={{ height: '2px' }} />
                                                        }
                                                        <div className="d-flex justify-content-between" >
                                                            <div className="" >
                                                                {
                                                                    data?.key === 'not_assigned' || data?.key === 'assigned' ?
                                                                        <NavLink to={`/service-request?agent_id=${data?.key}`}>
                                                                            <H5>
                                                                                {data?.status}
                                                                            </H5></NavLink>
                                                                        :
                                                                        <NavLink to={`/service-request?status=${data?.key}`}>
                                                                            <H5>
                                                                                {data?.status}
                                                                            </H5></NavLink>

                                                                }
                                                                {/* <P>{Connections}</P> */}
                                                            </div>
                                                            <div className="me-3">
                                                                <P>
                                                                    <span style={{fontSize:'11px'}} className={`badge badge-${data?.key}`}>
                                                                        {data?.count}
                                                                    </span>
                                                                </P>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                    </tbody >
                                </Table>
                            </div >
                        )}


                    </CardBody>
                </Card>
            </Col>
        </Fragment >
    )
}
export default ActivityReview;